import { getInventariosDetPanel } from "../../services/InventariosDetServices";
import { InventariosDetContext } from "./InventariosDetContext"

export const InventariosDetState = ({ children }) => {
    const getInventariosDetPanelData = async (searchAjuCab, searchDepoid,searchArt,numPagina, filas) => {
        let res = await getInventariosDetPanel(searchAjuCab,searchDepoid, searchArt,numPagina, filas);
        return res
    }
 
    return <InventariosDetContext.Provider value={{ 
        getInventariosDetPanelData,
    }} >
        {children}
    </InventariosDetContext.Provider>
}